import Reveal from "./Reveal";
import { Diya, JasmineStrand, FloralDivider } from "./Ornaments";

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-frame" aria-hidden="true" />
      <div className="footer-orn footer-diya-l">
        <Diya width={40} dur={6} />
      </div>
      <div className="footer-orn footer-diya-r">
        <Diya width={40} dur={5.2} delay={0.7} />
      </div>
      <div className="footer-orn footer-strand-l">
        <JasmineStrand width={220} />
      </div>
      <div className="footer-orn footer-strand-r">
        <JasmineStrand width={220} />
      </div>

      <div className="footer-inner">
        <Reveal>
          <h2 className="footer-thanks serif">Thank You</h2>
          <p className="footer-msg">
            We look forward to celebrating these beautiful moments with you.
          </p>
          <div className="footer-divider">
            <FloralDivider width={200} flowerFill="#f8f3ea" />
          </div>
          <div className="footer-sign kicker">With love,</div>
          <div className="footer-names serif">
            Divyanshi <span className="amp">&amp;</span> Divyashiv
          </div>
        </Reveal>
      </div>
    </footer>
  );
}
